import type { AgeData } from '@cinch-nx/data-search'
import { findSelectedOptionLabel, stringifyReferenceDataValue } from './utils'

const getFormattedFromYear = (yearSelection = -1, ageData: AgeData[]) => {
  if (yearSelection === -1) return ''
  return `From ${findSelectedOptionLabel(
    stringifyReferenceDataValue(ageData),
    yearSelection.toString(),
  )}`
}
const getFormattedToYear = (yearSelection = -1, ageData: AgeData[]) => {
  if (yearSelection === -1) return ''
  return `To ${findSelectedOptionLabel(
    stringifyReferenceDataValue(ageData),
    yearSelection.toString(),
  )}`
}
export const getFormattedYearRange = (
  fromYearSelection = -1,
  toYearSelection = -1,
  ageData: AgeData[],
) => {
  if (fromYearSelection === -1 && toYearSelection === -1) return ''

  const fromYear = getFormattedFromYear(fromYearSelection, ageData)
  let toYear = getFormattedToYear(toYearSelection, ageData)

  if (fromYear) {
    toYear = ` ${toYear.toLowerCase()}`
  }

  return `${fromYear}${toYear}`.trim()
}
